module.exports = __webpack_public_path__ + "static/media/icon_daySelected.c2127150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_daySelected.svg
// module id = 2416
// module chunks = 7